import { CHECK_BOX_VALUE } from "../../../constants";

export const initialState = {
  loading: false,
  errors: {},
  isPriceClassDataFound:false,
  isExpanded:true,
  priceClassData:[],
  searchResultData:[{
    name:'2*20',
    description:'fhgfhg',
    price_Class_id:5000000,
    last_Modified_User_Id:123,
    last_Modified_TimeStamp:'12/20/2023 : 10:30:00'
  },
  {
    name:'model',
    description:'tyuhjkg',
    price_Class_id:5000001,
    last_Modified_User_Id:456,
    last_Modified_TimeStamp:'12/20/2023 : 10:30:00'
  }],
  isPriceClassSearchedDataFound:false,
  isPriceClassDataSearched:false,
  priceClasseCount:0,
  selectedData: {
    name: '',
    description: '',
    active_Flag: CHECK_BOX_VALUE.yes,
    pageNumber: 1,
    pageSize: 25,
  },
  isSearchedPriceClassesResults :false,
};
